export type CreateMemberAddressFields = {
  streetAddress: string;
  city: string;
  provinceOrState: string;
  postalOrZipCode: string;
  country: string;
};

export type CreateMemberBillingAddress = CreateMemberAddressFields & {
  /** Design Step 2: "Check here if same as Member Address". */
  sameAsMemberAddress?: boolean;
};

const pickAddressFields = (
  address: CreateMemberAddressFields,
): CreateMemberAddressFields => ({
  streetAddress: address.streetAddress,
  city: address.city,
  provinceOrState: address.provinceOrState,
  postalOrZipCode: address.postalOrZipCode,
  country: address.country,
});

// Checking copies the Member Address. Unchecking keeps the copied values so
// staff can edit them.
export const setBillingSameAsMemberAddress = (
  billingAddress: CreateMemberBillingAddress,
  memberAddress: CreateMemberAddressFields,
  checked: boolean,
): CreateMemberBillingAddress =>
  checked
    ? { ...pickAddressFields(memberAddress), sameAsMemberAddress: true }
    : { ...billingAddress, sameAsMemberAddress: false };

// While the box is checked, the billing address follows each Member Address
// change.
export const syncBillingWithMemberAddress = (
  billingAddress: CreateMemberBillingAddress,
  memberAddress: CreateMemberAddressFields,
): CreateMemberBillingAddress =>
  billingAddress.sameAsMemberAddress
    ? { ...billingAddress, ...pickAddressFields(memberAddress) }
    : billingAddress;

// A manual billing edit makes the addresses different, so the box clears and
// a later Member Address change cannot overwrite the edit.
export const editBillingAddress = (
  billingAddress: CreateMemberBillingAddress,
  value: Partial<CreateMemberAddressFields>,
): CreateMemberBillingAddress => ({
  ...billingAddress,
  ...value,
  sameAsMemberAddress: false,
});
